import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ContextService } from '@maximizer/core/shared/data-access';
import { Octopus, OctopusResponseError } from '@maximizer/core/shared/domain';
import { map, Observable } from 'rxjs';

interface ExchangeConsentResponse extends Octopus.Response {
  Data?: { Consent: boolean };
}

@Injectable()
export class ExchangeConsentService {
  private readonly http = inject(HttpClient);
  private readonly context = inject(ContextService);

  get(): Observable<boolean> {
    return this.post(Octopus.Action.GET_EXCHANGE_CONSENT, {});
  }

  set(consent: boolean): Observable<boolean> {
    return this.post(Octopus.Action.SET_EXCHANGE_CONSENT, { Consent: consent });
  }

  private post(action: string, body: object): Observable<boolean> {
    return this.http.post<ExchangeConsentResponse>(`${this.context.api}${action}`, body).pipe(
      map((response) => {
        if (response.Code !== Octopus.ResponseStatusCode.Successful || !response.Data) {
          throw OctopusResponseError.fromResponse(response);
        }
        return response.Data.Consent === true;
      }),
    );
  }
}
